import Header from "../components/Header";
import MyFormLogic from "../components/ContactForm";
import Container from '@mui/material/Container';
import React, {useState, useEffect} from 'react';

const MyForm = () => {
    const {formData, handleChange, handleSubmit, error, result} = MyFormLogic();
    const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);

    const handleButtonClick = () => {
        setIsSubmitDisabled(true);
        handleSubmit();
    };

    useEffect(() => {
        //console.log('data changed');
        if (!error) {
            setIsSubmitDisabled(false);
        }
    }, [error]);

    formData.subject = "contact_form";
    return (
        <form onSubmit={handleSubmit}>
            <label>
                Name:
                <input type="text" name="name" className="full-width" value={formData.name} onChange={handleChange}/>
            </label>
            <label>
                Email:
                <input type="text" name="email" className="full-width" value={formData.email} onChange={handleChange}/>
            </label>
            <label>
                Phone Number (Optional):
                <input type="text" name="phone" className="full-width"
                       value={formData.phone}
                       onChange={handleChange}/>
            </label>
            <label>
                Message:
                <textarea name="message" className="full-width" value={formData.message} onChange={handleChange}/>
            </label>
            <button type="button" onClick={handleButtonClick} disabled={isSubmitDisabled}>Submit</button>
            {error && <p style={{color: 'red'}}>{error}</p>}
            {(!error || result) && <p>{result}</p>}
        </form>
    );
};

const Contact = (props) => (
    <>
        <Header title="Contact Us" sections={props.sections}/>
        <Container>
            <div>
                <div align="center"><a href="tel:5854207946">Call</a> or&nbsp;
                    <a href="sms:5854207946">text us</a> at <a href="tel:5854207946">(585) 420-7946</a></div>
                <div align="center"><a href="https://www.facebook.com/profile.php?id=61556715404192">Message us on
                    Facebook</a></div>
                <br/><br/>
                <div align="center">Or fill out and submit the form below</div>
                <MyForm/>
            </div>
        </Container>
    </>
);

export default Contact;